module.exports = __webpack_public_path__ + "067b6578682a038c1386dce9670cda7d.svg";